import { render } from "./BugModal.vue?vue&type=template&id=7a6cd296&scoped=true"
import script from "./BugModal.vue?vue&type=script&lang=js"
export * from "./BugModal.vue?vue&type=script&lang=js"

import "./BugModal.vue?vue&type=style&index=0&id=7a6cd296&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6cd296"]])

export default __exports__